import { Capacitor, type Plugin, type PluginListenerHandle, registerPlugin } from '@capacitor/core';

export type PendingShortcutPayload = {
  source?: string;
  type?: string;
};

interface ExoraShortcutsPlugin extends Plugin {
  updateShortcuts(options: { loggedIn: boolean }): Promise<void>;
  consumePendingShortcut(): Promise<PendingShortcutPayload>;
  addListener(
    eventName: 'shortcutTriggered',
    listenerFunc: (payload: PendingShortcutPayload) => void,
  ): Promise<PluginListenerHandle>;
}

export const ExoraShortcuts = registerPlugin<ExoraShortcutsPlugin>('ExoraShortcuts');

/**
 * Update iOS Home Screen Quick Actions based on auth state.
 * Logged out: only "Search Hotels"
 * Logged in: "Search Hotels", "Reservations", "Favourites"
 */
export async function updateQuickActions(loggedIn: boolean): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    console.log(`[Shortcuts] ${loggedIn ? 'setting logged-in shortcuts' : 'setting logged-out shortcuts'}`);
    await ExoraShortcuts.updateShortcuts({ loggedIn });
    console.log(`[Shortcuts] current shortcut items set | loggedIn=${loggedIn}`);
  } catch (e) {
    console.warn('[Shortcuts] Failed to update quick actions', e);
  }
}
